export default __webpack_public_path__ + "static/media/dice-1.2addd685.svg";